import {time} from './utils'

export default class AuthService
{
    constructor (
        APIService,
        expirePeriodInMinutes = 1,
        permissions = [],
        groups = [],
        baseRoot = false,
        refreshOnInit = false
    )
    {
        // APIService instance
        this.API = APIService
        if( this.API === undefined && window.API !== undefined ) {
            this.API = window.API
        }
        if( this.API === undefined ) {
            throw new Error('[AuthService] Please provide valid ApiService instance.')
        }

        // expire period
        if( expirePeriodInMinutes < 0.3 ) {
            throw new Error('[AuthService] Please provide greater value for "expirePeriodInMinutes".')
        }

        // + 5 seconds so we can be sure that they are expired in the backend too (if we support backend cache)
        this.expirePeriod = (parseInt(expirePeriodInMinutes) * 60) + 5

        // initial auth data
        this._permissions = permissions
        this._groups = groups
        this.authorizationLastUpdate = time()
        //

        this.baseRoot = baseRoot

        this.refreshStarted = false

        if( refreshOnInit ) {
            this.refreshAuthInformation()
        }
    }

    getPermissions()
    {
        this.checkForExpiredAuthData()
        return this._permissions
    }

    has(permission, addBaseRoot = true)
    {
        if(isArray(permission))
        {
            let authorized = true

            permission.forEach( element => {
                if( ! this.has(element, addBaseRoot) )
                {
                    authorized = false
                }
            })

            return authorized
        }

        if(addBaseRoot)
        {
            let baseRoot = ''
            if(this.baseRoot) {
                baseRoot = this.baseRoot + '.'
            }

            permission = baseRoot + permission
        }

        let permissions = this.getPermissions()

        return permissions.indexOf(permission) !== -1
    }

    getGroups()
    {
        this.checkForExpiredAuthData()
        return this._groups
    }

    hasGroup(groupName)
    {
        let groups = this.getGroups()

        if ( isArray(groups) ) {
            return groups.indexOf(groupName) !== -1
        }

        return Object.keys(groups).indexOf(groupName) !== -1
    }

    ////////////////////////////////////////

    checkForExpiredAuthData()
    {
        if( time() >= (this.authorizationLastUpdate + this.expirePeriod) )
        {
            this.refreshAuthInformation()
        }
    }

    refreshAuthInformation()
    {
        if( this.refreshStarted === false ) {
            this.refreshStarted = true

            return this.API.POST('auth', 'retrieve-auth-info', {}, {
                // do not show loaders
                onBeforeRequest() {},
                onAfterRequest() {}
            })
            .then( response => {
                this._permissions = response.getData('permissions')
                this._groups = response.getData('groups')

                this.authorizationLastUpdate = time()
                this.refreshStarted = false

                return this
            })
        }

        return Promise.resolve(this)
    }
}
